import store from '../../store'

export function autoplayHighlight() {	
	store.dispatch({type:'AUTOPLAY_HIGHLIGHT'})
}

export function clearAutoplayHighlight() {	
	store.dispatch({type:'CLEAR_AUTOPLAY_HIGHLIGHT'})
}
